<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Une erreur est survenue</h4>
    </div>
    <div class="modal-body">
      <div>Nous sommes désolés, une erreur est survenue lors de votre demande.</div>
    </div>
    <div class="modal-footer">
      <button type="button"
              class="btn btn-primary"
              @click="closeModal">Ok</button>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>
